
export default function PhotoGallery() {
  const images = [
    {
      url: 'https://public.readdy.ai/ai/img_res/0a238c1e92c9358565a3425702081663.jpg',
      alt: 'Attorney reviewing case documents'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Authentic%20Hispanic%20female%20legal%20professional%20in%20her%20thirties%20with%20tan%20skin%20and%20dark%20hair%20wearing%20business%20attire%20consulting%20with%20a%20client%20in%20a%20welcoming%20Las%20Cruces%20law%20office%20conference%20room%20with%20southwestern%20design%20elements%2C%20genuine%20portrait%20of%20a%20Latina%20attorney%20or%20paralegal%20with%20natural%20features%20and%20professional%20demeanor%2C%20realistic%20photography%20not%20AI%20generated&width=600&height=400&seq=gallery-consultation-002&orientation=landscape',
      alt: 'Client consultation meeting'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20southwestern%20law%20office%20reception%20area%20in%20Las%20Cruces%20with%20warm%20earth%20tones%20comfortable%20seating%20area%20professional%20legal%20environment%20with%20desert%20landscape%20artwork%20and%20natural%20lighting%2C%20welcoming%20legal%20practice%20waiting%20room%20with%20New%20Mexico%20cultural%20elements%2C%20realistic%20interior%20photography%20not%20AI%20generated&width=600&height=400&seq=gallery-office-interior-003&orientation=landscape',
      alt: 'Law office reception area'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Small%20professional%20legal%20team%20of%20two%20Hispanic%20attorneys%20one%20male%20and%20one%20female%20in%20their%20thirties%20and%20forties%20with%20tan%20and%20brown%20skin%20wearing%20professional%20business%20attire%20standing%20together%20in%20a%20Las%20Cruces%20law%20office%20with%20southwestern%20decor%2C%20genuine%20group%20portrait%20of%20New%20Mexico%20personal%20injury%20lawyers%20with%20Latino%20features%20and%20confident%20expressions%2C%20realistic%20photography%20not%20AI%20generated&width=600&height=400&seq=gallery-small-team-photo-010&orientation=landscape',
      alt: 'Legal team photo'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Authentic%20Hispanic%20male%20attorney%20in%20his%20fifties%20with%20brown%20skin%20and%20dark%20hair%20wearing%20business%20suit%20shaking%20hands%20with%20a%20satisfied%20client%20in%20a%20professional%20Las%20Cruces%20law%20office%20with%20southwestern%20design%20elements%20and%20natural%20lighting%2C%20genuine%20portrait%20of%20a%20New%20Mexico%20personal%20injury%20lawyer%20with%20Latino%20features%20and%20warm%20smile%2C%20realistic%20photography%20not%20AI%20generated&width=600&height=400&seq=gallery-handshake-005&orientation=landscape',
      alt: 'Successful case resolution'
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Small%20intimate%20professional%20law%20office%20conference%20room%20in%20Las%20Cruces%20with%20medium-sized%20wooden%20table%20four%20comfortable%20black%20leather%20chairs%20southwestern%20desert%20artwork%20on%20walls%20beautiful%20mountain%20views%20and%20desert%20landscape%20visible%20through%20windows%20cozy%20meeting%20space%20with%20warm%20earth%20tone%20walls%20and%20no%20people%20present%2C%20realistic%20interior%20photography%20not%20AI%20generated&width=600&height=400&seq=gallery-small-conference-room-mountain-views-009&orientation=landscape',
      alt: 'Conference room'
    }
  ];

  return (
    <section id="gallery" className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Our Professional Network
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 max-w-3xl mx-auto">
            Meet the experienced attorneys and medical professionals we work with in Las Cruces
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {images.map((image, index) => (
            <div 
              key={index}
              className="w-full h-48 sm:h-56 md:h-64 overflow-hidden rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:transform hover:scale-105"
            >
              <img 
                src={image.url}
                alt={image.alt}
                className="w-full h-full object-cover object-top"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
